var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addImage } from '../../Editor/CanvasService';
import { CANVAS_OBJECT_ADDED, UPLOADED_IMAGES, } from '../../Rutab/RutabConstants';
import { useCanvasSize } from '../../Editor/Hooks/useReadOnlyState';
import { uploadImage, } from '../../Actions/Rutab/DecalEditor.action';
import CartImages from './CartImages';
import { translate } from '../../Services/translation';
import { ImageSelectorDialogIconLibrary } from './ImageSelectorDialogIconLibrary';
export const ImageSelectorDialog = ({ canvas, onClose, }) => {
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const dispatch = useDispatch();
    useSelector((state) => state.decalEditor.objectCount);
    const uploadedImages = useSelector((state) => state.decalEditorAPI.uploadedImages);
    const cartImages = useSelector((state) => state.decalEditorAPI.cartImages);
    const canvasSize = useCanvasSize();
    const handleFileUpload = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file || !canvas)
            return;
        if (file.size > 20 * 1024 * 1024) {
            alert(translate('decal.imageselectordialog.alert.imagesizeupload.text'));
            return;
        }
        const allowedTypes = ['image/jpeg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
            alert('Only JPG and PNG files are allowed.');
            return;
        }
        setIsUploading(true);
        try {
            const uploadResponse = yield uploadImage(file);
            yield addImage(canvas, uploadResponse.imageSrc, canvasSize, uploadResponse.systemId);
            dispatch({
                type: UPLOADED_IMAGES,
                payload: { uploadedImages: [...uploadedImages, uploadResponse] },
            });
            const uploadedImage = canvas
                .getObjects()
                .find((obj) => obj.systemId === uploadResponse.systemId);
            if (uploadedImage) {
                uploadedImage.set({
                    'cart-image': uploadResponse,
                });
            }
            dispatch({ type: CANVAS_OBJECT_ADDED });
        }
        catch (error) {
            console.error('Error uploading image:', error);
            alert(translate('decal.imageselectordialog.alert.imageuploaderror.text'));
        }
        finally {
            setIsUploading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    });
    const handleImageClick = (image) => {
        if (canvas) {
            if (uploadedImages.find((img) => img.systemId === image.systemId)) {
                return;
            }
            addImage(canvas, image.imageSrc, canvasSize, image.systemId).then(() => {
                dispatch({
                    type: UPLOADED_IMAGES,
                    payload: { uploadedImages: [...uploadedImages, image] },
                });
                const uploadedImage = canvas
                    .getObjects()
                    .find((obj) => obj.systemId === image.systemId);
                if (uploadedImage) {
                    uploadedImage.set({
                        'cart-image': image,
                    });
                }
                dispatch({ type: CANVAS_OBJECT_ADDED });
            });
        }
    };
    const handleDeleteImage = (imageToDelete) => {
        const canvasImagesToDelete = canvas === null || canvas === void 0 ? void 0 : canvas.getObjects().filter((img) => img.systemId == imageToDelete.systemId);
        canvasImagesToDelete.forEach((img) => {
            canvas === null || canvas === void 0 ? void 0 : canvas.remove(img);
        });
        dispatch({
            type: UPLOADED_IMAGES,
            payload: {
                uploadedImages: uploadedImages.filter((img) => img.systemId !== imageToDelete.systemId),
            },
        });
    };
    const formatDimension = (value) => {
        return value > 0 ? `${Math.round(value)}` : '-';
    };
    return (_jsxs("div", { className: "side-dialog open image-selector-dialog-guide", children: [_jsx("button", { className: "side-dialog-close", onClick: () => onClose(), children: "\u00D7" }), _jsx("div", { className: "side-dialog-header", children: translate('decal.imageselectordialog.header') }), _jsxs("div", { className: "side-dialog-content", children: [_jsx("small", { className: "upload-text-center", children: translate('decal.imageselectordialog.uploadtext.text') }), _jsx("input", { type: "file", ref: fileInputRef, onChange: handleFileUpload, accept: ".jpg,.jpeg,.png", style: { display: 'none' } }), _jsxs("button", { className: "upload-btn", onClick: () => { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: isUploading, children: [isUploading ? _jsx("div", { className: "spinner" }) : null, isUploading
                                ? translate('decal.imageselectordialog.button.select.loading.text')
                                : translate('decal.imageselectordialog.button.select.text')] }), uploadedImages.length > 0 && (_jsxs("div", { className: "uploaded-images-container", children: [_jsx("h4", { className: "section-title", children: translate('decal.imageselectordialog.usedimages.header') }), _jsx("div", { className: "uploaded-images-grid", children: uploadedImages.map((image, index) => (_jsxs("div", { className: "image-card", children: [_jsxs("div", { className: "image-preview", children: [_jsx("img", { src: image.imageSrc, alt: `${image.fileName || `Uploaded image ${index + 1}`}`, onClick: () => {
                                                        canvas &&
                                                            addImage(canvas, image.imageSrc, canvasSize, image.systemId);
                                                        dispatch({ type: CANVAS_OBJECT_ADDED });
                                                    } }), _jsx("button", { className: "delete-button", onClick: (e) => {
                                                        e.stopPropagation();
                                                        handleDeleteImage(image);
                                                    }, title: translate('decal.imageselectordialog.usedimages.delete.title'), children: "\u2715" }), _jsx("div", { className: "image-overlay", children: _jsx("span", { children: translate('decal.imageselectordialog.usedimage.clicktoadd.text') }) })] }), _jsxs("div", { className: "image-info", children: [_jsx("div", { className: "file-name", title: image.fileName, children: image.fileName ||
                                                        translate('decal.imageselectordialog.usedimage.header.text') }), _jsxs("div", { className: "size-info", children: [_jsxs("div", { className: "quality high", children: [_jsx("span", { children: translate('decal.imageselectordialog.usedimage.resolutionhigh.text') }), _jsxs("span", { children: [formatDimension(image.maxSizeHighQualityMm.width), ' ', "\u00D7", ' ', formatDimension(image.maxSizeHighQualityMm.height), ' ', "mm"] })] }), _jsxs("div", { className: "quality medium", children: [_jsx("span", { children: translate('decal.imageselectordialog.usedimage.resolutionmedium.text') }), _jsxs("span", { children: [formatDimension(image.maxSizeMediumQualityMm.width), ' ', "\u00D7", ' ', formatDimension(image.maxSizeMediumQualityMm.height), ' ', "mm"] })] })] })] })] }, index))) })] })), _jsx(CartImages, { cartImages: cartImages, onImageClick: handleImageClick }), _jsx(ImageSelectorDialogIconLibrary, { canvas: canvas })] })] }));
};
